import { Typography } from 'components/Text/TextStyle/TextStyle';
import { TitleFontSize } from './Title';

export const computeTitleTypography = (titleFontSizes: TitleFontSize): Typography => {
    return `Title${titleFontSizes}`;
};
